export class UserInformation  {
  public Message: string;
}





// WEBPACK FOOTER //
// ./src/app/dossier/user-information.ts